import { LogoElement } from "@redotech/redo-model/forge/review-forge-types";
import { memo, useContext } from "react";
import { Flex } from "../../flex";
import { InspectorConfig } from "../../inspector";
import { BrandKitContext } from "../review-form-editor-contexts";

export const ReviewsLogo = memo(function ReviewsLogo({
  element,
}: {
  element: LogoElement;
}) {
  const brandKit = useContext(BrandKitContext);

  return (
    <Flex justify="center">
      <img
        alt="Store logo"
        src={brandKit.images.logoUrl}
        style={{ width: element.widthPercentage + "%" }}
      />
    </Flex>
  );
});

export const logoInspector: InspectorConfig<LogoElement> = {
  sections: [
    {
      fields: [
        {
          widget: "slider",
          min: 0,
          max: 100,
          path: "widthPercentage",
          label: "Width Percentage",
        },
      ],
    },
  ],
};
